import { InjectionToken } from '@angular/core';

export const TIMEOUT_POPUP_CONFIG = new InjectionToken<TimeoutPopupConfig>(
  'TIMEOUT_POPUP_CONFIG',
  {
    providedIn: 'root',
    factory: () => ({
      timeoutDuration: 10,
      logoutDuration: 5,
      keepAliveUrl: '/oeptheme/chcp/images/imgPlaceholder100x100.gif',
    }),
  },
);

export interface TimeoutPopupConfig {
  timeoutDuration: number;
  logoutDuration: number;
  keepAliveUrl: string;
}
